exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".audio audio {\n  display: none;\n}\n.audio img {\n  vertical-align: -0.125em;\n}\n.audio .anticon {\n  cursor: pointer;\n}\n.audio-play::before,\n.audio-play::after {\n  content: \"\";\n  display: table;\n}\n.audio-play::after {\n  clear: both;\n}\n.audio-play.is-left .audio-icon,\n.audio-play.is-left .audio-time {\n  float: left;\n}\n.audio-play.is-right .audio-icon,\n.audio-play.is-right .audio-time {\n  float: right;\n}\n.audio-icon {\n  width: 14px;\n}\n.audio-icon > :first-child {\n  width: inherit;\n  height: inherit;\n}\n.audio-time {\n  margin: 0 5px;\n}\n", ""]);

// exports
